import { render, staticRenderFns } from "./CalendarChampionshipItemComponent.vue?vue&type=template&id=4f93c72d&scoped=true"
import script from "./CalendarChampionshipItemComponent.vue?vue&type=script&lang=ts"
export * from "./CalendarChampionshipItemComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f93c72d",
  null
  
)

export default component.exports